import React, { useState } from 'react';

import { Button2, VideoEmbed } from '@c';
import { isYouTubeId, parseVideoUrl } from '@helps/parseVideoUrl';

import { FiTrash2 } from 'react-icons/fi';

const Videos = ({
    value = [],
    onChange = () => {},
    videosClassName = '',
    videoClassName = '',
    iconClassName = '',
    frameClassName = '',
    buttonClassName = '',
    buttonsClassName = '',
}) => {
    const [isAddVideo, setIsAddVideo] = useState(false);
    const [link, setLink] = useState('');

    return (
        <>
            <div className={videosClassName}>
                {value.map((el, i) => (
                    <div key={i} className={videoClassName}>
                        <FiTrash2
                            className={iconClassName}
                            size={25}
                            color="white"
                            onClick={() =>
                                onChange(value.filter((_, idx) => idx !== i))
                            }
                        />
                        <VideoEmbed
                            value={el}
                            className={frameClassName}
                        />
                    </div>
                ))}
            </div>
            {isAddVideo ? (
                <>
                    <input
                        value={link}
                        onChange={({ target: { value } }) => setLink(value)}
                        placeholder="Ссылка на видео"
                    /> 
                    <div className={buttonsClassName}>
                        <Button2
                            title="Добавить"
                            className={buttonClassName}
                            onClick={() => {
                                const trimmedLink = link.trim();
                                const parsed = parseVideoUrl(trimmedLink);
                                const id =
                                    parsed?.type === 'youtube'
                                        ? parsed.id
                                        : parsed
                                        ? trimmedLink
                                        : isYouTubeId(trimmedLink)
                                        ? trimmedLink
                                        : '';

                                if (!id) {
                                    alert(
                                        'Не удалось распознать ссылку на видео'
                                    );
                                    return;
                                }

                                onChange([...value, id]);
                                setLink('');
                                setIsAddVideo(false);
                            }}
                        />
                        <Button2
                            title="Отмена"
                            className={buttonClassName}
                            onClick={() => setIsAddVideo(false)}
                        />
                    </div>
                </>
            ) : (
                <Button2
                    title="Добавить видео"
                    className={buttonClassName}
                    onClick={() => setIsAddVideo(true)}
                />
            )}
        </>
    );
};

export { Videos };
